import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './features/auth/LoginPage';
import ConditionalLayout from './components/layout/ConditionalLayout';
import ProtectedRoute from './components/ProtectedRoute';
import ChangePasswordPage from './features/auth/ChangePasswordPage';
import AddVanPage from './features/vans/AddVanPage';
import ManageVansPage from './features/vans/ManageVansPage';
import ManageLoadsPage from './features/loads/ManageLoadsPage';
import ManageWholesaleLoads from './features/wholesaleinventory/ManageWholesaleInventory';
import AddLoadPage from './features/loads/AddLoadPage';
import AddWholesaleLoad from './features/wholesaleinventory/AddWholesaleInventory';
import CreateOrderPage from './features/vanuser/CreateOrder';
import ManageVanOrders from './features/vanuser/VanOrdersManage';
import MessageAlert from './components/common/MessageAlert';
import ManageOrders from './features/orders/ManageOrders';



import HomeRedirect from './components/common/HomeRedirect';
import SearchProduct from './features/vanuser/SearchProduct';
import ManageCoupons from './features/coupons/ManageCoupons';
import AddCoupon from './features/coupons/AddCoupon';
import CreateWholesaleOrder from './features/wholesaleuser/CreateOrder';
import ManageWholesaleOrders from './features/wholesaleuser/WholesaleOrdersManage';
export default function App() {
  return (
    <Router>
      <MessageAlert />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={<ProtectedRoute><ConditionalLayout /></ProtectedRoute>}
        >
           <Route index element={<HomeRedirect />} />
          <Route path="settings/change-password" element={<ChangePasswordPage />} />
          <Route path="vans/manage" element={<ManageVansPage />} />
          <Route path="vans/add" element={<AddVanPage />} />
          <Route path="vans/edit/:id" element={<AddVanPage />} />
          <Route path="loads/manage" element={<ManageLoadsPage />} />
          <Route path="loads/add" element={<AddLoadPage />} />
          <Route path="order/create" element={<CreateOrderPage />} />
          <Route path="order/manage" element={<ManageOrders />} />
          <Route path="/vanorder/manage" element={<ManageVanOrders />} />
          <Route path="/vanload/search" element={<SearchProduct />} />
          <Route path="coupons/add" element={<AddCoupon />} />
          <Route path="coupons/add/:id" element={<AddCoupon />} />
          <Route path="coupons/manage" element={<ManageCoupons />} />
<Route path="wholesaleinventory/manage" element={<ManageWholesaleLoads />} />
          <Route path="wholesaleinventory/add" element={<AddWholesaleLoad />} />
          <Route path="wholesaleorder/create" element={<CreateWholesaleOrder />} />
          <Route path="wholesaleorder/manage" element={<ManageWholesaleOrders />} />
        </Route>
      </Routes>
    </Router>
  );
}
